import cn from "classnames";
import React from "react";
import { LoadingDots } from "web-ui";

import type {
  LeaderboardParticipant,
  LeaderboardResponse,
} from "../../api/languageChallenge";
import styles from "../../styles/Leaderboard.module.scss";
import LeaderboardEntry from "../LeaderboardEntry";

export interface Props {
  className?: string;
  challengeId: string;
  leaderboard: LeaderboardResponse | null;
  leaderboardLoading: boolean;
}

export const downloadLeaderboardCsv = (
  participants: LeaderboardParticipant[],
) => {
  const header = "user_ID,XP";
  const rows = participants.map(p => `${p.userId},${p.gainedXp}`);
  const csv = [header, ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "external-leaderboard.csv";
  link.click();
  URL.revokeObjectURL(url);
};

const ExternalLeaderboard = ({
  className,
  leaderboard,
  leaderboardLoading,
}: Props) => (
  <div className={cn(className, styles.wrap)}>
    {leaderboardLoading ? (
      <div className={styles.loading}>
        <LoadingDots manualPositioning={true} type="screen-white" />
      </div>
    ) : leaderboard ? (
      <>
        {leaderboard.leaderboard.map((participant, index) => (
          <LeaderboardEntry
            className={styles.entry}
            key={index}
            participant={participant}
          />
        ))}
        {leaderboard.self && (
          <LeaderboardEntry
            className={styles["entry-self"]}
            key="self"
            participant={leaderboard.self}
          />
        )}
        {leaderboard.counterpart && (
          <LeaderboardEntry
            className={styles["entry-counterpart"]}
            key="counterpart"
            participant={leaderboard.counterpart}
          />
        )}
      </>
    ) : null}
  </div>
);
export default ExternalLeaderboard;
